import { render, staticRenderFns } from "./ShopBundleProductAgreementRecord.vue?vue&type=template&id=37343eb1&"
import script from "./ShopBundleProductAgreementRecord.vue?vue&type=script&lang=js&"
export * from "./ShopBundleProductAgreementRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports